import React, { useState, useEffect, useContext } from "react";
import {
  useQuery,
  useMutation,
  useManualQuery,
  ClientContext,
} from "graphql-hooks";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";

import {
  Container,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Header from "./Header.js";
import { GET_TERM_DATA_BY_TERM_UUID } from "../../graphQL/term_qry";

import { TEAM_TERM_ALL_PERIODS_QUERY } from "../../graphQL/team_term_period_qry";
import { GET_TEAM_DATA_BY_UUID } from "../../graphQL/team_term_qry";

import { GET_ALL_TEAMS_QUERY } from "../../graphQL/team_qry";

import Diversity1Icon from "@mui/icons-material/Diversity1";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ActivitiesDialog from "./ActivitiesDialog.js";
import ResourcesDialog from "./ResourcesDialog.js";
import MemberAttendanceInfoDialog from "./MemberAttendanceInfoDialog.js";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import { project_url } from "../../constants/Data";

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -35px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.2rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    paddingTop: 0,
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  dataGridStyle: {
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
    },

    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 14,
    },
  },
}));

const CurrentSprint = () => {
  const classes = useStyles();
  const [loadContent, setLoadContent] = useState(false);
  const [loadData, setLoadData] = useState(false);
  // static data
  const termUuid = "15e57b17-c41d-411c-a0e9-45b55117fd6f";
  const teamUuid = "489f4e45-c009-496d-bb96-f07ca41179b1";
  const resourcesData = [
    {
      teamId: 1,
      members: [
        {
          memberId: 1,
          name: "David Johnson",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 2,
          name: "Susan Sanders",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },

      ],
      staff: [
        {
          staffId: 1,
          name: "Hooshyar",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },

      ],
    },
    {
      teamId: 2,
      members: [
        {
          memberId: 1,
          name: "David Johnson",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 2,
          name: "Susan Sanders",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },

      ],
      staff: [
        {
          staffId: 1,
          name: "Hooshyar",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },

      ],
    },
    {
      teamId: 3,
      members: [
        {
          memberId: 1,
          name: "David Johnson",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 2,
          name: "Susan Sanders",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 4,
          name: "Don Song",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 5,
          name: "Joseph Foo",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
      staff: [
        {
          staffId: 1,
          name: "Hooshyar",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 4,
          name: "Rose",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 5,
          name: "Robinia",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
    },
    {
      teamId: 4,
      members: [
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "Yes",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 4,
          name: "Don Song",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 5,
          name: "Joseph Foo",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
      staff: [
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 4,
          name: "Rose",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 5,
          name: "Robinia",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
    },
    {
      teamId: 5,
      members: [
        {
          memberId: 1,
          name: "David Johnson",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 2,
          name: "Susan Sanders",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 4,
          name: "Don Song",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 5,
          name: "Joseph Foo",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
      staff: [
        {
          staffId: 1,
          name: "Hooshyar",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 4,
          name: "Rose",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 5,
          name: "Robinia",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
    },
    {
      teamId: 6,
      members: [
        {
          memberId: 1,
          name: "David Johnson",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 2,
          name: "Susan Sanders",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 4,
          name: "Don Song",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 5,
          name: "Joseph Foo",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
      staff: [
        {
          staffId: 1,
          name: "Hooshyar",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 4,
          name: "Rose",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 5,
          name: "Robinia",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
    },
    {
      teamId: 7,
      members: [
        {
          memberId: 1,
          name: "David Johnson",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 2,
          name: "Susan Sanders",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 4,
          name: "Don Song",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 5,
          name: "Joseph Foo",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
      staff: [
        {
          staffId: 1,
          name: "Hooshyar",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 4,
          name: "Rose",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 5,
          name: "Robinia",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
    },
    {
      teamId: 8,
      members: [
        {
          memberId: 1,
          name: "David Johnson",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 2,
          name: "Susan Sanders",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 4,
          name: "Don Song",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 5,
          name: "Joseph Foo",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
      staff: [
        {
          staffId: 1,
          name: "Hooshyar",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 4,
          name: "Rose",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 5,
          name: "Robinia",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
    },
    {
      teamId: 9,
      members: [
        {
          memberId: 1,
          name: "David Johnson",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 2,
          name: "Susan Sanders",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 4,
          name: "Don Song",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 5,
          name: "Joseph Foo",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
      staff: [
        {
          staffId: 1,
          name: "Hooshyar",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 4,
          name: "Rose",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 5,
          name: "Robinia",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
    },
    {
      teamId: 10,
      members: [
        {
          memberId: 1,
          name: "David Johnson",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 2,
          name: "Susan Sanders",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 4,
          name: "Don Song",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 5,
          name: "Joseph Foo",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
      staff: [
        {
          staffId: 1,
          name: "Hooshyar",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 4,
          name: "Rose",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 5,
          name: "Robinia",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
    },
    {
      teamId: 11,
      members: [
        {
          memberId: 1,
          name: "David Johnson",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 2,
          name: "Susan Sanders",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 4,
          name: "Don Song",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 5,
          name: "Joseph Foo",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
      staff: [
        {
          staffId: 1,
          name: "Hooshyar",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 4,
          name: "Rose",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 5,
          name: "Robinia",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
    },
    {
      teamId: 12,
      members: [
        {
          memberId: 1,
          name: "David Johnson",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 2,
          name: "Susan Sanders",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 3,
          name: "Mary Smith",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 4,
          name: "Don Song",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          memberId: 5,
          name: "Joseph Foo",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
      staff: [
        {
          staffId: 1,
          name: "Hooshyar",
          role: "Product Owner",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 2,
          name: "Sandy",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 3,
          name: "David",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 4,
          name: "Rose",
          role: "Scrum Master",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
        {
          staffId: 5,
          name: "Robinia",
          role: "Developer",
          getMemberTermAttendance: [
            {
              id: "1",
              actualDate: "03/11/2025",
              attended: "No",
              desc: "",
              event: "Story Point checking",
              eventType: "General Activity",
              period: "Applicants Submission",
              scheduledDate: "03/11/2025",
            },
            {
              id: "2",
              actualDate: "04/24/2025",
              attended: "No",
              desc: "Team gathering to celebrate the end of the Sprint.",
              event: "Sprint Party",
              eventType: "General Activity",
              period: "Sprint Break",
              scheduledDate: "04/24/2025",
            },
          ],
        },
      ],
    },
  ];
  const members = [
    {
      memberId: 1,
      name: "David Johnson",
      role: "Product Owner",
    },
    {
      memberId: 2,
      name: "Susan Sanders",
      role: "Developer",
    },
    {
      memberId: 3,
      name: "Mary Smith",
      role: "Developer",
    },
    {
      memberId: 4,
      name: "Don Song",
      role: "Product Owner",
    },
    {
      memberId: 5,
      name: "Joseph Foo",
      role: "Scrum Master",
    },
  ];
  const staff = [
    { staffId: 1, name: "Hooshyar", role: "Product Owner" },
    { staffId: 2, name: "Sandy", role: "Scrum Master" },
    { staffId: 3, name: "David", role: "Developer" },
    { staffId: 4, name: "Rose", role: "Scrum Master" },
    { staffId: 5, name: "Robinia", role: "Developer" },
  ];
  ///
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const [termName, setTermName] = useState("");
  const [periodDataList, setPeriodDataList] = useState([]);
  const [teamsList, setTeamsList] = useState([]);
  const [sprintStartDate, setSprintStartDate] = useState(null); //first period in the current term that is in-sprint
  const [sprintEndDate, setSprintEndDate] = useState(null); //end date of the last period in the current term that is in-sprint.
  const [teamTermData, setTeamTermData] = useState([]);
  const [openActivitiesDialog, setOpenActivitiesDialog] = useState(null);
  const [openResourcesDialog, setOpenResourcesDialog] = useState(null);
  const [openAttendanceDialog, setOpenAttendanceDialog] = useState(null);
  const [activitiesRows, setActivitiesRows] = useState([]);
  const [getTermDataQuery] = useManualQuery(GET_TERM_DATA_BY_TERM_UUID);
  const [getTeamTermPeriodsQuery] = useManualQuery(TEAM_TERM_ALL_PERIODS_QUERY);
  const [getTeamTermDataQuery] = useManualQuery(GET_TEAM_DATA_BY_UUID);
  const [fetchAllTeams] = useManualQuery(GET_ALL_TEAMS_QUERY);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });

  let clientId = 0;
  if (localStorage.getItem("clientId"))
    clientId = localStorage.getItem("clientId");
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  useEffect(() => {
    (() => getTermData())();
  }, [teamTermData]);

  useEffect(() => {
    (() => getTeamTermData())();
  }, []);
  useEffect(() => {
    (() => getTeamsList())();
  }, []);

  useEffect(() => {
    setActivitiesRows(flattenRows(periodDataList));
  }, [periodDataList]);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`${project_url}/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };
  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat =
      format !== null
        ? formatter1.formatToParts(dayDate)
        : formatter2.formatToParts(dayDate);
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "day").value +
        " " +
        dayFormat.find((a) => a.type == "month").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "YYYYmonthDD") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value +
        ", " +
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find((a) => a.type == "month").value +
        "/" +
        dayFormat.find((a) => a.type == "day").value +
        "/" +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    }
  };

  const getTeamsList = async () => {
    const {
      loading: teamsListLoading,
      error: teamsListError,
      data: teamsListData,
    } = await fetchAllTeams({
      variables: {
        clientId: parseInt(clientId),
      },
    });
    if (!teamsListLoading && teamsListData && teamsListData.allTeams) {
      let rows = [];
      teamsListData.allTeams.map((team) => {
        let row = [];
        const findRow = resourcesData.find((r) => {
          return r.teamId === parseInt(team.teamId);
        });
        row["teamId"] = team.teamId;
        row["name"] = team.name;
        row["noOfResources"] = findRow
          ? findRow.members.length + findRow.staff.length
          : "";
        rows.push(row);
      });
      setTeamsList(rows);
    }
  };

  const getTermData = async () => {
    const {
      loading: loadingTermData,
      error: errorTermData,
      data: dataTermData,
    } = await getTermDataQuery({
      variables: {
        termUuid: termUuid,
      },
    });
    if (
      !loadingTermData &&
      dataTermData &&
      dataTermData.getTermDataByTermUuid
    ) {
      setTermName(dataTermData.getTermDataByTermUuid.name);
      setSprintStartDate(
        new Date(
          dataTermData.getTermDataByTermUuid.startDate
        ).toLocaleDateString("sv-SE")
      );
      getTeamTermPeriods();
    }
  };

  const getTeamTermData = async () => {
    if (teamUuid && termUuid) {
      const {
        loading: loadingTeamTermData,
        error: errorTeamTermData,
        data: dataTeamTermData,
      } = await getTeamTermDataQuery({
        variables: {
          teamUuid: teamUuid,
          termUuid: termUuid,
        },
      });

      if (
        !loadingTeamTermData &&
        dataTeamTermData &&
        dataTeamTermData.getTeamTermData
      ) {
        setTeamTermData(dataTeamTermData.getTeamTermData);
      }
    }
  };
  const getTeamTermPeriods = async () => {
    if (teamTermData.teamTermId) {
      const {
        loading: loadingTeamTermPeriods,
        error: errorTeamTermPeriods,
        data: dataTeamTermPeriods,
      } = await getTeamTermPeriodsQuery({
        variables: {
          teamTermId: parseInt(teamTermData.teamTermId),
        },
      });
      if (
        !loadingTeamTermPeriods &&
        dataTeamTermPeriods &&
        dataTeamTermPeriods.teamTermAllPeriodList
      ) {
        const inSprintFiltered = dataTeamTermPeriods.teamTermAllPeriodList.filter(
          (period) => {
            return period.inSprint;
          }
        );

        setPeriodDataList(inSprintFiltered);
        setLoadData(true);

        if (dataTeamTermPeriods.teamTermAllPeriodList.length > 0) {
          const lastPeriodEndDate = new Date(
            dataTeamTermPeriods.teamTermAllPeriodList.slice(-1)[0].endDate
          );
          setSprintEndDate(lastPeriodEndDate.toLocaleDateString("sv-SE"));
        }
      }
    }
  };
  const getResourcesData = (teamId, name) => {
    const findRow = resourcesData.find((r) => {
      return r.teamId === parseInt(teamId);
    });
    setOpenResourcesDialog({
      members: findRow ? findRow.members : [],
      staff: findRow ? findRow.staff : [],
      name,
    });
  };
  const getAttendanceData = (teamId, name) => {
    const findRow = resourcesData.find((r) => {
      return r.teamId === parseInt(teamId);
    });
    setOpenAttendanceDialog({
      rows: findRow ? findRow : [],
      name,
    });
  };
  const activitiesColumns = [
    {
      field: "period",
      headerName: "Period",
      headerClassName: "super-app-theme--header",
      minWidth: 130,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (params.row.period) {
          return (
            <Typography variant="h2" style={{ paddingTop: 10 }}>
              {params.row.period}
            </Typography>
          );
        } else if (params.row.startDate && params.row.endDate)
          return (
            <Box>
              <Typography variant="h5" className="row-span-empty">
                <b>Start Date:&nbsp;</b>
                {params.row.startDate}
              </Typography>
              <Typography variant="h5" className="row-span-empty">
                <b>End Date:&nbsp;</b>
                {params.row.endDate}
              </Typography>
            </Box>
          );
        return <span className="row-span-empty"></span>;
      },
    },
    {
      field: "event",
      headerClassName: "super-app-theme--header",
      headerName: "Event",
      minWidth: 150,
      sortable: false,
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
    {
      field: "desc",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 220,
      sortable: false,
      align: "center",
      flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "scheduledDate",
      headerName: "Scheduled Date",
      headerClassName: "super-app-theme--header",
      minWidth: 170,
      sortable: false,
      align: "center",
      //  flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
    {
      field: "actualDate",
      headerClassName: "super-app-theme--header",
      headerName: "Actual Date",
      minWidth: 150,
      sortable: false,
      align: "center",
      //  flex: 1,
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{params.value}</div>;
      },
    },
  ];
  const periodColumns = [
    {
      field: "name",
      headerName: "Period Name",
      minWidth: 150,
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];
  const teamColumns = [
    {
      field: "name",
      headerName: "Team Name",
      minWidth: 150,
      flex: 1,
      disableColumnMenu: true,
    },
    {
      field: "noOfResources",
      headerName: "No of Resources",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <StyledTooltip title="Activities">
              <IconButton style={{ padding: 0 }}>
                <CalendarMonthOutlinedIcon
                  onClick={() => setOpenActivitiesDialog(rows.row.name)}
                />
              </IconButton>
            </StyledTooltip>
            <Box pr={2} />
            <StyledTooltip title="Resources">
              <IconButton style={{ padding: 0 }}>
                <Diversity1Icon
                  onClick={() =>
                    getResourcesData(rows.row.teamId, rows.row.name)
                  }
                />
              </IconButton>
            </StyledTooltip>
            <Box pr={2} />
            <StyledTooltip title="Attendance">
              <IconButton style={{ padding: 0 }}>
                <HowToRegOutlinedIcon
                onClick={() =>
                  getAttendanceData(rows.row.teamId, rows.row.name)
                }
                />
              </IconButton>
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];
  const attendanceColumns = [
    {
      field: "period",
      headerClassName: "super-app-theme--header",
      headerName: "Period",
      minWidth: 150,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "event",
      headerName: "Event",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "eventType",
      headerName: "Event Type",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "description",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "scheduledDate",
      headerClassName: "super-app-theme--header",
      headerName: "Scheduled Date",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "actualDate",
      headerClassName: "super-app-theme--header",
      headerName: "Actual Date",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "attended",
      headerClassName: "super-app-theme--header",
      headerName: "Member Attended?",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];
  const flattenRows = (data) => {
    let rowId = 1;
    let eventRows = [];
    if (data.length === 0) return [];
    data.forEach((period, index) => {
      if (period.teamTermEvents.length > 0 && period.inSprint) {
        period.teamTermEvents.forEach((event, index) => {
          eventRows.push({
            id: rowId++,
            teamTermPeriodId: period.teamTermPeriodId,
            period: index === 0 ? period.name : null, // Only show in the first row
            startDate: index === 1 ? period.startDate : null, // Only show in the secound row
            endDate: index === 1 ? period.endDate : null,
            event: event.name,
            desc: event.desc,
            eventType: event.eventType,
            teamTermEventId: event.teamTermEventId,
            desc: event.desc,
            scheduledDate: event.scheduledDate,
            actualDate: event.actualDate,
            attendanceRequired: event.attendanceRequired,
          });
        });
      }
      // For the case that there is not any event under period
      if (period.teamTermEvents.length === 0 && period.inSprint) {
        eventRows.push({
          id: rowId++,
          teamTermPeriodId: null,
          period: period.name,
          startDate: null,
          endDate: null,
          dateRange: null,
          event: null,
          desc: null,
          scheduledDate: "",
          actualDate: "",
        });
      }
    });
    return eventRows;
  };
  function DataGridTitle() {
    return (
      <Box pt={1}>
        <Typography variant="h1" style={{ fontSize: 18, paddingBottom: 6 }}>
          Sprint Periods
        </Typography>
        <Divider />
      </Box>
    );
  }
  function TeamsDataGridTitle() {
    return (
      <Box pt={1}>
        <Typography variant="h1" style={{ fontSize: 18, paddingBottom: 6 }}>
          Sprint Teams
        </Typography>
        <Divider />
      </Box>
    );
  }
  if (loadContent && loadData)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: "Current Sprint", link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography
              variant="body1"
              style={{ marginBottom: 10, fontWeight: 600 }}
            >
              Current Sprint
            </Typography>
          </Box>
          <Divider />
          <Grid container style={{ paddingTop: 20 }}>
            <Grid
              item
              xs={4}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography style={{ paddingRight: 5 }} variant="h2">
                Sprint Name:
              </Typography>
              <Typography variant="h3">{termName}</Typography>
            </Grid>
            <Grid
              item
              xs={4}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography style={{ paddingRight: 5 }} variant="h2">
                Sprint Start Date:
              </Typography>
              {sprintStartDate && (
                <Typography variant="h3">
                  {dayFormat(sprintStartDate.substring(0, 10), "monthDDYYYY")}
                </Typography>
              )}
            </Grid>
            <Grid
              item
              xs={4}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Typography style={{ paddingRight: 5 }} variant="h2">
                Sprint End Date:
              </Typography>
              {sprintEndDate && (
                <Typography variant="h3">
                  {dayFormat(sprintEndDate.substring(0, 10), "monthDDYYYY")}
                </Typography>
              )}
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Grid item md={6}>
              <Box pt={4}>
                <DataGrid
                  className={classes.dataGridStyle}
                  columns={periodColumns}
                  rows={periodDataList}
                  showCellRightBorder={true}
                  hideFooter={true}
                  autoWidth={true}
                  autoHeight={true}
                  slots={{
                    toolbar: DataGridTitle,
                  }}
                  rowHeight={40}
                  getRowId={(row) => row.teamTermPeriodId}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box pt={4}>
                <DataGrid
                  className={classes.dataGridStyle}
                  columns={teamColumns}
                  rows={teamsList}
                  showCellRightBorder={true}
                  hideFooter={true}
                  autoWidth={true}
                  autoHeight={true}
                  slots={{
                    toolbar: TeamsDataGridTitle,
                  }}
                  getRowId={(row) => row.teamId}
                  rowHeight={40}
                />
              </Box>
            </Grid>
          </Grid>
          {openActivitiesDialog && (
            <ActivitiesDialog
              name={openActivitiesDialog}
              columns={activitiesColumns}
              rows={activitiesRows} //this data must be according selected team row
              closeDialog={() => setOpenActivitiesDialog(false)}
            />
          )}
          {openResourcesDialog && (
            <ResourcesDialog
              name={openResourcesDialog.name}
              members={openResourcesDialog.members}
              staff={openResourcesDialog.staff}
              closeDialog={() => setOpenResourcesDialog(null)}
            />
          )}
          {openAttendanceDialog && (
            <MemberAttendanceInfoDialog
              termUuid={termUuid}
              termName={termName}
              termTeams={openAttendanceDialog.name}
              columns={attendanceColumns}
              memberAttendanceData={openAttendanceDialog.rows}
              closeDialog={() => setOpenAttendanceDialog(null)}
            />
          )}
        </div>
      </div>
    );
};
export default CurrentSprint;
